import axios from "axios";
import { getClientIp } from "request-ip";
import { captureException } from "@sentry/nextjs";

const httpm = axios.create();

httpm.interceptors.request.use(
  function (config) {
    // Do something before request is sent

    const modifiedHeaders = prepareHeaders(config);
    config.headers = modifiedHeaders;

    return config;
  },
  function (error) {
    // Do something with request error
    console.error(error);
    captureException(error);

    return Promise.reject(error);
  }
);

function prepareHeaders(config) {
  try {
    const modifiedHeaders = { ...config.headers } || {};

    const hasGetServerSidePropsReq = config.hasOwnProperty(
      "getServerSidePropsReq"
    );

    if (hasGetServerSidePropsReq) {
      const getServerSidePropsReq = config["getServerSidePropsReq"];

      // adds the client ip to the axios config headers
      modifiedHeaders["x-original-client-ip"] = getClientIp(
        getServerSidePropsReq
      );

      // adds the client user-agent to the axios config headers
      modifiedHeaders["user-agent"] =
        modifiedHeaders["user-agent"] ||
        getServerSidePropsReq.headers["user-agent"];

      // adds the client cookie to the axios config headers
      if (getServerSidePropsReq.headers["cookie"]) {
        modifiedHeaders["cookie"] =
          modifiedHeaders["cookie"] || getServerSidePropsReq.headers["cookie"];
      }
    }

    return modifiedHeaders;
  } catch (error) {
    console.error(error);
    captureException(error);
  }
}

export default httpm;
